import { MANY_YOUDAO } from "@/graphql/translator.graphql";
import { ITranslatorYoudao } from "@/interfaces/translator.interface";
import { pubmedState } from "@/stores/pubmed";
import { useLazyQuery } from "@apollo/react-hooks";
import { useCallback, useMemo } from "react";
import { useRecoilValue } from "recoil";
import { useMatomo } from "./useMatomo";
import { usePubmedState } from "./usePubmed";
import useTranslation from "./useTranslation";

export const useYoudao = () => {
  const [queryYoudao, { loading, data }] = useLazyQuery<
    { manyYoudao: ITranslatorYoudao[] },
    { ids: string[] }
  >(MANY_YOUDAO);

  const { i18n } = useTranslation();

  const { setTranslation, setTranslator } = usePubmedState();
  const { translation, translator } = useRecoilValue(pubmedState);

  const { statsTranslate } = useMatomo();

  useMemo(() => {
    if (data) {
      setTranslation(
        Object.fromEntries(data?.manyYoudao?.map((y) => [y?.id, y]))
      );
      statsTranslate(data?.manyYoudao?.map((e) => e?.id));
    }
  }, [data]);

  const getTargetYoudaoStatus = (id: string) => {
    if (translator[id]) {
      return true;
    }
    return false;
  };

  const setTargetYoudao = (id: string) => {
    setTranslator({ [id]: !getTargetYoudaoStatus(id) });
    if (!getTargetYoudaoStatus(id) && !translation[id]) {
      queryYoudao({ variables: { ids: [id] } });
    }
  };

  const getTargetYoudao = useCallback(
    (id: string) => {
      if (i18n.language === "en") {
        return null;
      }
      if (getTargetYoudaoStatus(id)) {
        return translation[id];
      }
      return null;
    },
    [translation, translator]
  );

  const setAllYoudao = (ids: string[]) => {
    setTranslator(Object.fromEntries(ids.map((id) => [id, true])));
    queryYoudao({ variables: { ids } });
  };

  const removeAllYoudao = (ids: string[]) => {
    setTranslator(Object.fromEntries(ids.map((id) => [id, false])));
  };

  return {
    getTargetYoudao,
    getTargetYoudaoStatus,
    setTargetYoudao,
    loading,
    setAllYoudao,
    removeAllYoudao,
  };
};
